import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { WizardPageTemplate } from '@ratehub/base-ui';

import CoverageStandardQuestions from '../components/CoverageStandardQuestions';
import CoverageDisabilityQuestions from '../components/CoverageDisabilityQuestions';
import CoverageGroupQuestions from '../components/CoverageGroupQuestions';
import { InsuranceTypeValues } from '../definitions/CurrentDocument';


function CoverageDetailsPage({
    formType,
    values,
    onSubmit,
}) {
    return (
        <WizardPageTemplate
            name={values.name}
            onContinue={onSubmit}
            isAutoFocusEnabled={false}
            messages={{
                TITLE: (
                    <FormattedMessage
                        id="InsLifeWizard.CoverageDetails.title"
                        defaultMessage="Tell us about your coverage needs"
                    />
                ),
            }}
        >
            {/* Choose a question set depending on the insurance type */}
            <Choose>
                {/* Standard Questions */}
                <When condition={formType === InsuranceTypeValues.STANDARD}>
                    <CoverageStandardQuestions
                        values={values}
                    />
                </When>

                {/* Disability Questions */}
                <When condition={formType === InsuranceTypeValues.DISABILITY}>
                    <CoverageDisabilityQuestions
                        values={values}
                    />
                </When>

                {/* Group Questions */}
                <When condition={formType === InsuranceTypeValues.GROUP}>
                    <CoverageGroupQuestions
                        values={values}
                    />
                </When>
            </Choose>
        </WizardPageTemplate>
    );
}

CoverageDetailsPage.propTypes = {
    formType: PropTypes.oneOf(Object.values(InsuranceTypeValues)).isRequired,
    values: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
};


export default observer(CoverageDetailsPage);
